import { ReactNode, ReactText } from "react";

export default function isReactText(
  children: ReactNode
): children is ReactText {
  return typeof children === "string" || typeof children === "number";
}
